'use strict';

var OOP = require('utils/oop');
var ReportDownloadListView = require('components/profile/views/device_report_download_list_view');

module.exports = OOP.extend(
    Marionette.LayoutView,
    {
        template: require('components/profile/templates/device_report_download_dialog'),

        regions: {
            download: '.js-download-table',
        },

        onShow: function () {
            this.showChildView(
                'download',
                new ReportDownloadListView({
                    listResult: this.options.listResult,
                    title: this.options.title,
                    reportID: this.options.reportID,
                    controller: this.options.controller,
                    currentSortCol: this.options.currentSortCol,
                    currentSortDesc: this.options.currentSortDesc,
                })
            );
        },

        serializeData: function () {
            return {
                title: this.options.title,
            };
        },

        onRender: function () {
            $('.modal-dialog').addClass('modal-lg');
        },
    },
    'DeviceReportDialogView'
);
